import { render } from "./CustomReportDialog.vue?vue&type=template&id=acc1fbd0&ts=true"
import script from "./CustomReportDialog.vue?vue&type=script&lang=ts"
export * from "./CustomReportDialog.vue?vue&type=script&lang=ts"

import "./CustomReportDialog.vue?vue&type=style&index=0&id=acc1fbd0&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__